import React from "react";
import { ArrowRightIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/offer";
type CTAButtonProps = {
  label: string;
  id?: string;
  size?: "md" | "lg";
  pulse?: boolean;
  className?: string;
};
export function CTAButton({
  label,
  id,
  size = "lg",
  pulse = false,
  className = ""
}: CTAButtonProps) {
  const sizing = size === "lg" ? "px-6 py-5 text-[17px] sm:text-lg md:px-10 md:py-6 md:text-xl" : "px-5 py-4 text-base md:px-8 md:text-lg";
  const handleClick = () => {
    window.fbq?.("track", "InitiateCheckout");
  };
  return <a id={id} href={CHECKOUT_URL} onClick={handleClick} className={`group relative flex w-full items-center justify-center gap-3 rounded-2xl bg-gold-400 text-center font-extrabold uppercase leading-snug tracking-tight text-brand-950 shadow-[0_8px_0_0_#D99A00,0_18px_40px_-10px_rgba(245,180,0,0.55)] transition-[transform,box-shadow,background-color] duration-150 ease-out hover:bg-gold-300 active:translate-y-[4px] active:shadow-[0_4px_0_0_#D99A00,0_10px_24px_-10px_rgba(245,180,0,0.55)] focus:outline-none focus-visible:ring-4 focus-visible:ring-gold-200 md:w-auto ${sizing} ${pulse ? "animate-cta-pulse" : ""} ${className}`} data-id="element-108" data-mp="33p64csr3oulz">
      <span className="text-balance" data-id="element-109" data-mp="1i802ka149rhi">{label}</span>
      <ArrowRightIcon className="h-6 w-6 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-110" data-mp="1n8edbzu3rfj8" />
    </a>;
}